const DEFAULT_DISCOVER_SEARCH_ZOOM = 12;

const DISCOVER_SEARCH_ZOOM_BY_LAYER = Object.freeze({
    venue: 16,
    address: 16,
    street: 14,
    neighbourhood: 13,
    neighborhood: 13,
    borough: 11,
    locality: 11,
    localadmin: 11,
    county: 8,
    macrocounty: 8,
    region: 6,
    macroregion: 6,
    country: 4,
    dependency: 4,
    continent: 3,
    ocean: 3,
    marinearea: 3,
});

function normalizeLayer(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

function readSuggestionLayer(geocoded, suggestion) {
    return normalizeLayer(
        suggestion?.layer
        || suggestion?.raw?.layer
        || geocoded?.layer
        || geocoded?.raw?.layer
    );
}

export function resolveDiscoverSearchZoom(geocoded, suggestion) {
    const layer = readSuggestionLayer(geocoded, suggestion);
    return DISCOVER_SEARCH_ZOOM_BY_LAYER[layer] || DEFAULT_DISCOVER_SEARCH_ZOOM;
}

export function toDiscoverSearchCameraRequest({ geocoded, suggestion, requestId }) {
    if (!geocoded || typeof geocoded !== 'object') {
        return null;
    }

    const latitude = geocoded.latitude;
    const longitude = geocoded.longitude;

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return null;
    }

    return {
        id: requestId,
        center: {
            lat: latitude,
            lng: longitude,
        },
        zoom: resolveDiscoverSearchZoom(geocoded, suggestion),
    };
}

export function toDiscoverSearchMarker({ geocoded, requestId }) {
    if (!geocoded || typeof geocoded !== 'object') {
        return null;
    }

    const latitude = geocoded.latitude;
    const longitude = geocoded.longitude;

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return null;
    }

    const label = geocoded.label || geocoded.fullAddress || 'Search result';

    return {
        id: requestId,
        label,
        coordinate: {
            lat: latitude,
            lng: longitude,
        },
        color: '#ffdf74',
    };
}
